import {getIsAgeRestricted} from '../../../../common/getIsAgeRestricted';
import {NormalListViewItem} from '../../../../design-system/organisms/NormalListViewItem/NormalListViewItem';
import {useBuyTicketFlow} from '../../../../domain/buy/ticket/hook/useBuyTicketFlow';
import {
  NormalListViewItem as NormalListViewItemType,
  QueryFromPage,
} from '../../../../graphql/generated/types';
import {
  LOG_PRODUCT_CLICK,
  LOG_SERIES_CLICK,
} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {useLogin} from '../../../../user/useLogin.hook';
import {CommonItemProps} from '../../type';

export function NormalListView({item}: CommonItemProps) {
  const {user} = useLogin();
  const normalListViewItem = item as NormalListViewItemType;
  const {startTicketProcess} = useBuyTicketFlow();
  return (
    <NormalListViewItem
      isAgeRestricted={getIsAgeRestricted({
        age: user?.age,
        authenticatedAt: user?.authenticatedAt,
        ageGrade: normalListViewItem.ageGrade,
        selfCensorship: normalListViewItem.selfCensorship,
      })}
      item={normalListViewItem}
      imageLazyLoad={false}
      className="px-15pxr"
      {...putTiaraObjectProps(normalListViewItem.eventLog)}
      onClick={e => {
        if (normalListViewItem.isSingle) {
          LOG_PRODUCT_CLICK(e);
        } else {
          LOG_SERIES_CLICK(e);
        }
        if (normalListViewItem?.continueData && normalListViewItem.seriesId) {
          startTicketProcess({
            seriesId: normalListViewItem.seriesId,
            targetProductId: normalListViewItem?.continueData?.productId,
            nonstopWatching: false,
            queryFrom: QueryFromPage.Inven,
            pickExactly: false,
          });
        }
      }}
    />
  );
}
